export default __webpack_public_path__ + "static/media/towrs.3ec49efd.jpg";